import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { createDTHESubmittal, updateDTHEQuotation } from 'src/_helpers/api';

const name = 'dtheSubmittals';

const initialState = {
  dtheSubmittals: [],
  error: null,
};

const addDTHESubmittalAsync = createAsyncThunk(`${name}/add-dthe-submittal`, async (submittalData, { rejectWithValue }) => {
  try {
    const response = await createDTHESubmittal(submittalData);
    //console.log('🚀 ~ API response received:', response);
    return response;
  } catch (error) {
    //console.error('🚀 ~ Error occurred in addSubmittalAsync:', error);
    return rejectWithValue(error.response ? error.response.data : 'Unknown error');
  }
});

const updateDTHESubmittalAsync = createAsyncThunk(`${name}/update-dthe-submittal`, async (submittalData) => {
  console.log('🚀 ~ submittalData:', submittalData)
  return await updateDTHEQuotation(submittalData)
})

const dtheSubmittalSlice = createSlice({
  name,
  initialState,
  reducers: {
    resetState: (state) => {
      state.dtheSubmittals = [];
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(addDTHESubmittalAsync.pending, (state) => {
        state.error = null;
      })
      .addCase(addDTHESubmittalAsync.fulfilled, (state, action) => {
        state.dtheSubmittals.push(action.payload);
      })
      .addCase(addDTHESubmittalAsync.rejected, (state, action) => {
        state.error = action.error;
      })
      .addCase(updateDTHESubmittalAsync.pending, (state) => {
        state.error = null;
      })
      .addCase(updateDTHESubmittalAsync.fulfilled, (state, action) => {
        const index = state.dtheSubmittals.findIndex(s => s.id === action.payload.id);
        if (index !== -1) state.dtheSubmittals[index] = action.payload;
      })
      .addCase(updateDTHESubmittalAsync.rejected, (state, action) => {
        state.error = action.error;
      });
  },
});

export const dtheSubmittalActions = {
  ...dtheSubmittalSlice.actions,
  addDTHESubmittalAsync,
  updateDTHESubmittalAsync,
};

export const dtheSubmittalsReducer = dtheSubmittalSlice.reducer;
